module.exports = __webpack_public_path__ + "assets/img/information-title-tvc-2.dbf74c5e.png";